import $ from 'jquery';

$.fn.toggleFormSection = function toggleFormSection(display) {
  this.find('input').addBack('input').prop('disabled', !display);
  this.toggle(!!display);
};
